import { useState } from "react";
import { useLocation, useSearchParams, useNavigate } from "react-router-dom";
import { Box, Popover, MenuItem, Typography, Button } from "@mui/material";
import Iconify from "src/components/iconify/Iconify";

export default function TenantPopover({ selectedTenant, tenants, dispatch, setSelectedTenant, collapse }) {
    const { pathname } = useLocation();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [tenantAnchorEl, setTenantAnchorEl] = useState(null);

    const handleOpenTenantPopover = (event) => {
        setTenantAnchorEl(event.currentTarget);
    };

    const handleCloseTenantPopover = () => {
        setTenantAnchorEl(null);
    };

    const handleTenantSelect = (tenant) => {
        dispatch(setSelectedTenant(tenant));

        // Update URL with new tenantId
        const newSearchParams = new URLSearchParams(searchParams);
        newSearchParams.set('tenantId', tenant.tenantId);
        navigate(`${pathname}?${newSearchParams.toString()}`, { replace: true });

        handleCloseTenantPopover();
    };

    const isTenantPopoverOpen = Boolean(tenantAnchorEl);

    if (!tenants || tenants.length <= 1 || !selectedTenant) {
        return null;
    }

    return (
        <Box sx={{ px: 2, py: 1 }}>
            <Button
                fullWidth
                variant="outlined"
                onClick={handleOpenTenantPopover}
                sx={{
                    justifyContent: collapse ? "center" : "flex-start",
                    px: collapse ? 1 : 2,
                }}
            >
                {collapse ? (
                    <Typography variant="body2" fontWeight="bold">
                        {selectedTenant.shortCode}
                    </Typography>
                ) : (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, width: "100%" }}>
                        <Typography variant="body2" fontWeight="bold">
                            {selectedTenant.shortCode}
                        </Typography>
                        <Iconify icon="eva:chevron-down-fill" sx={{ ml: "auto" }} />
                    </Box>
                )}
            </Button>
            <Popover
                open={isTenantPopoverOpen}
                anchorEl={tenantAnchorEl}
                onClose={handleCloseTenantPopover}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
            >
                <Box sx={{ minWidth: 180 }}>
                    {tenants.map((tenant) => (
                        <MenuItem
                            key={tenant.tenantId}
                            onClick={() => handleTenantSelect(tenant)}
                            selected={selectedTenant?.tenantId === tenant.tenantId}
                        >
                            <Typography variant="body2">{tenant.shortCode}</Typography>
                        </MenuItem>
                    ))}
                </Box>
            </Popover>
        </Box>
    );
}
